import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=06084329"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=06084329&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports